
// =========================
// FILTERS
// =========================
import './app/filters/propHasIdOne.filter';

$(function () {
  $('body').on('click', ".flex-center-nav[data-toggle='modal'][href='#login']", function () {
    window.ceresStore.dispatch('loadComponent', 'login-modal');
  });
});
